export default __webpack_public_path__ + "static/media/ethereum_logo.7f7c9962.svg";